import { type MiauRequest } from '@eduzz/miau-types';

import 'fastify';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Express {
    interface Request extends MiauRequest {
      _?: never;
    }
  }
}

declare module 'fastify' {
  interface FastifyRequest extends MiauRequest {
    _?: never;
  }
}
